import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import NavbarHome from "../../../components/ui/NavbarHome";
import { devURL } from "../../../utils";
import { createTransfer, login, register } from "../../../Api";
import Swal from "sweetalert2";
import Loading from "../../../components/ui/Loading";


export default function Verify() {
    let { token, id,walletId,username } = useParams();
    console.log(token, username)
   
    localStorage.setItem("swToken", token);
    console.log("get token", localStorage.getItem("swToken"));

    let count = 0
    useEffect(async() => {
        if (count === 0) {
            count = 1
            await login(username)
            console.log("triger")
            await createTransfer(id,walletId);
            try {
                Swal.fire({
                  title: "You have approved the transaction",
                  html: "<p>Click the button below to go back to the app</b>",
                  confirmButtonColor: "#2878bb",
                  confirmButtonText: "Sure",
                }).then((result) => {
                  if (result.isConfirmed) {
                    window.location.href = "scopexmobile://login";
                  }
                });
              } catch (error) {
                console.error("Error verifying device:", error);
                toast.error("Error verifying device");
              }
        }
    }, []);

    return (
        <Loading/>
    );
}
